/** @format */

import React, {
  useEffect,
  useState,
  forwardRef,
  ForwardRefRenderFunction,
  useImperativeHandle,
  useRef
} from 'react'
import styled from 'styled-components'
import { _$, Checkbox, Input, Form, FormItem, Select, Option } from '@king-design/react'
interface Props {
  className?: string
  currentRule?: any[]
}

const RuleContent: ForwardRefRenderFunction<any, Props> = ({ className, currentRule }, ref) => {
  const [checkedRules, setChosed] = useState([])
  const formRef = useRef<any>()
  useEffect(() => {
    if (currentRule && Array.isArray(currentRule)) {
      setChosed(currentRule.filter(i => i.selected === 1))
    }
  }, [currentRule])
  const days = [
    {
      label: _$('3天以上'),
      value: 3
    },
    {
      label: _$('5天以上'),
      value: 5
    },
    {
      label: _$('10天以上'),
      value: 10
    }
  ]
  // 添加chosed
  const addRules = (id: number) => {
    const chosedItem = currentRule.find(i => i.itemId === id)
    chosedItem.selected = 1
    setChosed(state => [].concat(state, chosedItem))
  }
  // 去选
  const delRules = (id: number) => {
    const delItem = currentRule.find(i => i.itemId === id)
    delItem.selected = 0
    setChosed(state => state.filter(i => i.itemId !== id))
  }
  // select day
  const dealSelectDay = ({ id, day }) => {
    setChosed(state =>
      state.map(i => {
        if (i.itemId === id) {
          i.days = day
        }
        return i
      })
    )
  }
  const dealThreshold = ({ id, threshold }) => {
    setChosed(state =>
      state.map(i => {
        if (i.itemId === id) {
          i.threshold = threshold
        }
        return i
      })
    )
  }

  useImperativeHandle(ref, () => ({
    getCheckedRules: async () => {
      const validate = await formRef?.current?.validate()
      return validate ? Promise.resolve(checkedRules) : Promise.resolve(false)
    }
  }))

  return (
    <div className={className}>
      <Form layout="vertical" starOnRequired={true} ref={formRef}>
        {Array.isArray(currentRule)
          ? currentRule.map(i => (
              <div className="rule-item" key={i.itemId}>
                <div className="rule-item-check">
                  <Checkbox
                    value={i.selected === 1 ? true : false}
                    onChangeValue={value => {
                      value ? addRules(i.itemId) : delRules(i.itemId)
                    }}
                  />
                  <span className="rule-item-name">{i.metricName}</span>
                </div>
                <FormItem
                  hideLabel={true}
                  value={i?.days}
                  rules={{
                    required: i.selected ? true : false
                  }}
                  className="rule-item-day"
                >
                  <Select
                    value={i?.days}
                    width={150}
                    onChangeValue={day => {
                      dealSelectDay({ id: i.itemId, day })
                    }}
                    disabled={i.selected ? false : true}
                  >
                    {days.map(i => (
                      <Option key={i.value} value={i.value}>
                        {i.label}
                      </Option>
                    ))}
                  </Select>
                </FormItem>
                <label>小于</label>
                <FormItem
                  hideLabel={true}
                  value={i.threshold}
                  rules={{
                    required: i.selected ? true : false,
                    amount: i.selected ? true : false
                  }}
                  className="rule-item-input"
                >
                  <Input
                    width={150}
                    frozenOnInput
                    value={i?.threshold}
                    disabled={checkedRules.find(el => el.itemId === i.itemId) ? false : true}
                    onChangeValue={threshold => dealThreshold({ id: i.itemId, threshold })}
                  />
                </FormItem>
                <span>{i?.units}</span>
              </div>
            ))
          : ''}
      </Form>
      <div className="rule-desc">
        {_$('*注：勾选复选框后，才能设置检查指标值，最多保留两位小数')}
      </div>
    </div>
  )
}
export default styled(forwardRef(RuleContent))`
  max-height: 359px;
  .k-checkbox {
    margin-right: 4px;
  }
`
